import classNames from 'classnames';
import React, { FC } from 'react';

import { Trash } from '@/assets';
import { ImageSize } from '@/constants';
import { useGetImageUrl } from '@/utils';

import { message } from '../../atoms';
import { useDeleteBackgroundMutation } from '../../services';
import { ConfirmModal } from '../ConfirmModal';
import styles from './styles.module.scss';

interface Props {
  alt: string;
  id: number;
  imageSize?: ImageSize;
  large?: boolean;
  onDelete?: () => void;
  testId: number;
  url: string;
}

export const InteractiveImage: FC<Props> = ({
  alt,
  id,
  imageSize,
  large,
  onDelete,
  testId,
  url,
}) => {
  const [deleteBackground] = useDeleteBackgroundMutation();

  const getImageUrl = useGetImageUrl();

  const handleDelete = async (event: React.MouseEvent<Element, MouseEvent>) => {
    event.stopPropagation();
    event.preventDefault();

    ConfirmModal({
      cancelText: 'Отменить',
      okText: 'Удалить',
      onOk: async () => {
        await deleteBackground({ id, testId });
        message({
          title: 'Изображение удалено',
          type: 'success',
        });

        if (onDelete) {
          onDelete();
        }
      },
      text: 'Вы действительно хотите удалить изображение?',
      title: 'Удалить изображение?',
    });
  };

  return (
    <div className={classNames(styles.container, large && styles.large)}>
      <img
        src={getImageUrl({ options: imageSize ? { resize: imageSize } : undefined, url })}
        alt={alt}
        className={styles.image}
      />
      <div className={styles.deleteIcon} onClick={handleDelete}>
        <Trash className={styles.icon} />
      </div>
    </div>
  );
};
